import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { heatDiary as actions } from "actions/index";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { INPUT_FIELDS } from "./fields/heat_diary_breeding";
import FormButtons from "components/form/FormButtons";

class HeatDiaryBreedingEntryForm extends Component {
  renderFields() {
    const { viewMode, editMode, values } = this.props;
    return INPUT_FIELDS.map((field, i) => {
      return (
        <Field
          key={i}
          values={values}
          viewMode={viewMode}
          editMode={editMode}
          {...field}
        />
      );
    });
  }

  render() {
    const { errors, dirty, isSubmitting, viewMode, editMode, cancel } =
      this.props;
    return (
      <Form>
        {this.renderFields()}
        <br />
        <FormButtons
          viewMode={viewMode}
          editMode={editMode}
          isSubmitting={isSubmitting}
          errors={errors}
          dirty={dirty}
          cancel={cancel}
          linkTo={"/userhome/dashboard/heat_diary"}
        />
        <br />
      </Form>
    );
  }
}

HeatDiaryBreedingEntryForm = withFormik({
  mapPropsToValues({ valuesToEdit, pet }) {
    return {
      type: valuesToEdit.type || "breeding",
      breedingDate:
        moment(valuesToEdit.breedingDate).format("YYYY-MM-DD") ||
        moment().format("YYYY-MM-DD"),
      breedingNotes: valuesToEdit.breedingNotes || "",
      _id: valuesToEdit._id || "",
      _pet: valuesToEdit._pet || pet._id,
    };
  },
  validationSchema: Yup.object().shape({
    breedingDate: Yup.date().required("required"),
    breedingNotes: Yup.string().max(500, "max-500"),
  }),
  handleSubmit(values, { props, setSubmitting }) {
    const successRoute = `${props.defaultRoute}/view_entries_breeding`;
    if (props.editMode) {
      return props.updateHeatDiaryBreedingEntry(
        values,
        setSubmitting,
        props.history,
        successRoute
      );
    }
    props.addHeatDiaryBreedingEntry(
      values,
      setSubmitting,
      props.history,
      successRoute
    );
  },
})(HeatDiaryBreedingEntryForm);

export default withRouter(connect(null, actions)(HeatDiaryBreedingEntryForm));
